import userTypes from 'constants/userTypes';

export default [userTypes.PARTNER];
